<template>
  <div class="reference">
    <h2 class="lma-headline">Content-based licensing subscription service</h2>
    <div class="reference__tab">
      <div
        class="reference__tab-item"
        :class="{
          'reference__tab-item--active': currentReferenceTab === 'partners',
        }"
        @click="handleChangeTab('partners')"
      >
        <button type="button" class="reference__tab-button">Partners</button>
      </div>
      <div
        class="reference__tab-item"
        :class="{
          'reference__tab-item--active': currentReferenceTab === 'themes',
        }"
        @click="handleChangeTab('themes')"
      >
        <button type="button" class="reference__tab-button">Themes</button>
      </div>
    </div>
    <div ref="carousel" class="reference__filter">
      <h3
        v-for="item in filterList"
        :key="`filter-item-${item.id}`"
        class="reference__filter-item"
        :class="{
          'reference__filter-item--active':
            currentReferenceFilterId === item.id,
        }"
        @click="handleClickFilter(item.id)"
      >
        <button type="button" class="reference__filter-button">
          {{ item.name }}
        </button>
      </h3>
    </div>
    <div class="reference__list">
      <div
        v-for="(item, index) in filteredContents"
        v-show="expanded || index < 5"
        :key="`content-item-${item.id}`"
        class="reference__list-item lma-card"
        :class="`reference__list-item--${(index % 5) + 1}`"
        @click="handleClickReferenceListItem(item)"
      >
        <div class="reference__list-image-wrapper">
          <img
            :src="`/theme/rbFront/img/w/mediaArtSolution/contents/${item.thumbnail}`"
            :alt="item.title"
            class="reference__list-image"
          />
        </div>
      </div>
    </div>
    <div class="reference__disclimer">
      * This represents only a portion of the art we offer. If you would like to
      explore more of our art collection, please feel free to contact us.
    </div>
    <div class="reference__list-foot">
      <div
        class="lma-button lma-button lma-button--outline-red reference__button"
        type="button"
        @click="expanded = !expanded"
      >
        {{ buttonText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentReferenceTab: {
      type: String,
      required: true,
    },
    currentReferenceFilterId: {
      type: Number,
      required: true,
    },
    filterList: {
      type: Array,
      required: true,
    },
    filteredContents: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      slickInitialized: false,
      isDestroying: false,
    }
  },
  computed: {
    buttonText() {
      return this.expanded ? 'Show Less' : 'Show More'
    },
  },
  watch: {
    async filterList() {
      await this.safeDestroySlick()
      await this.$nextTick()
      if (!this.isDestroying) {
        this.initSlick()
      }
    },
    expanded() {
      if (!this.expanded) {
        this.$nextTick(() => {
          const offsetTop =
            document.querySelector('.reference').getBoundingClientRect().top +
            window.pageYOffset
          window.scrollTo({
            top: offsetTop,
            // behavior: 'smooth',
          })
        })
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    setTimeout(() => {
      this.initSlick()
    }, 100)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.safeDestroySlick()
  },
  methods: {
    async handleChangeTab(tab) {
      if (window.innerWidth <= 1080) {
        await this.safeDestroySlick()
      }
      this.expanded = false
      this.$emit('change-tab', tab)
    },
    handleClickFilter(id) {
      this.expanded = false
      this.$emit('click-filter', id)
    },
    async safeDestroySlick() {
      if (this.slickInitialized && this.$refs.carousel) {
        this.isDestroying = true
        try {
          await new Promise((resolve) => setTimeout(resolve, 0)) // 마이크로태스크 큐 비우기
          $(this.$refs.carousel).slick('unslick') // eslint-disable-line no-undef
          this.slickInitialized = false
        } catch (error) {
          console.error('Error destroying slick:', error)
        } finally {
          this.isDestroying = false
        }
      }
    },
    handleClickReferenceListItem(item) {
      this.$emit('click-reference-list-item', item)
    },
    async initSlick() {
      if (
        window.innerWidth <= 1080 &&
        !this.slickInitialized &&
        !this.isDestroying &&
        this.$refs.carousel
      ) {
        try {
          await new Promise((resolve) => setTimeout(resolve, 0)) // DOM 업데이트 대기
          const $carousel = $(this.$refs.carousel) // eslint-disable-line no-undef
          if ($carousel.length) {
            $carousel.slick({
              dots: false,
              infinite: false,
              speed: 300,
              variableWidth: true,
              arrows: false,
              touchThreshold: 100,
              swipe: true,
              slidesToScroll: this.currentReferenceTab === 'themes' ? 4 : 3,
            })
            this.slickInitialized = true
          }
        } catch (error) {
          // console.error('Error initializing slick:', error)
        }
      }
    },
    handleResize() {
      if (window.innerWidth <= 1080) {
        this.initSlick()
      } else {
        this.safeDestroySlick()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.reference {
  padding: 80px 0 160px;
  &__tab {
    display: flex;
    justify-content: center;
    width: 400px;
    margin: 60px auto 0;
    border-radius: 100px;
  }
  &__tab-item {
    flex: 1;
    border-radius: inherit;
    color: #999;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    padding: 0 60px;
    height: 56px;

    display: flex;
    align-items: center;
    &--active {
      background-color: #ea1917;
      color: #fff;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__tab-button {
    color: inherit;
  }
  &__filter {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 60px;
    margin-top: 40px;
    border-bottom: solid 1px #ddd;
  }
  &__filter-item {
    color: #999;
    padding-bottom: 16px;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;

    &--active {
      color: #000;
      font-weight: 600;
      border-bottom: solid 2px #000;
    }
  }
  &__filter-button {
    color: inherit;
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 60px;
    box-sizing: border-box;
  }
  &__list-item {
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    &--1 {
      width: 100%;
      height: 720px;
    }
    &--2 {
      width: calc(50% - 10px);
      height: 470px;
    }
    &--3 {
      width: calc(50% - 10px);
      height: 470px;
    }
    &--4 {
      width: calc(66.2% - 10px);
      height: 620px;
    }
    &--5 {
      width: calc(33.8% - 10px);
      height: 620px;
    }

    :hover {
      cursor: pointer;
    }
  }
  &__list-image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }
  &__list-image {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
  }
  &__disclimer {
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
    margin-top: 16px;
    color: #666;
  }
  &__list-foot {
    display: flex;
    justify-content: center;
    margin-top: 60px;
  }
  .lma-headline {
    color: #ea1917;
  }

  @media screen and (max-width: 1080px) {
    padding: 40px 0 80px;
    &__tab {
      margin-top: 40px;
    }
    &__tab-item {
      flex: 0;
      font-size: 16px;
      height: 35px;
      padding: 0 36px;
    }
    &__filter-container {
      width: 100%;
      overflow-x: auto;
      box-sizing: border-box;
      padding: 0 16px;
    }
    &__filter {
      gap: 0 24px;
      margin: 32px 16px 0;
      padding: 0 8px;
      display: block;
    }
    &__filter-item {
      display: inline-block;
      padding-bottom: 12px;
      font-size: 16px;
      line-height: 19.2px;
    }
    &__list {
      margin-top: 20px;
      padding: 0 16px;
      flex-direction: column;
      gap: 8px;
    }
    &__list-image-wrapper {
      font-size: 0;
    }
    &__list-item {
      width: 100%;
      height: auto;
    }
    &__list-image {
      position: static;
      object-fit: initial;
    }
    &__list-foot {
      margin-top: 43px;
    }
    &__disclimer {
      font-size: 14px;
      line-height: 18.2px;
      font-weight: 400;
      padding: 0 16px;
    }

    ::v-deep .slick-slide {
      margin-left: 24px;
    }
  }
}
</style>
